import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large AttachDocumentForm",
    title: "Прикрепление документа",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        class: "w-full",
        placeholder: "Тип документа",
        options: _ctx.data_state.types.list,
        loading: _ctx.data_state.types.is_loading,
        failed: _ctx.data_state.types.is_failed,
        "is-invalid": _ctx.state_form$.type.$error,
        "validation-errors": _ctx.state_form$.type.$errors,
        "error-text": "При получении списка типов произошла ошибка",
        value: _ctx.state.type,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.type) = $event)),
        "infinite-scroll": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadTypes(_ctx.data_state.types.pagination.current_page))),
        onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreTypes(_ctx.data_state.types.pagination.current_page + 1)))
      }, null, 8, ["options", "loading", "failed", "is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        type: "date",
        class: "mt-2 w-full",
        placeholder: "Дата",
        "is-invalid": _ctx.state_form$.date.$error,
        "validation-errors": _ctx.state_form$.date.$errors,
        value: _ctx.state.date,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.date) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      (_ctx.isTariff)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 0,
            type: "date",
            class: "mt-2 w-full",
            placeholder: "Дата окончания договора",
            "is-invalid": _ctx.state_form$.expirationDate.$error,
            "validation-errors": _ctx.state_form$.expirationDate.$errors,
            value: _ctx.state.expirationDate,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.expirationDate) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_input, {
        class: "mt-2 w-full",
        placeholder: "Номер приложения",
        "is-invalid": _ctx.state_form$.number.$error,
        "validation-errors": _ctx.state_form$.number.$errors,
        value: _ctx.state.number,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.number) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_file_reader, {
        class: "mt-3 w-full",
        placeholder: "Выберите документ",
        accept: "application/pdf",
        "is-invalid": _ctx.state_form$.files.$error,
        "validation-errors": _ctx.state_form$.files.$errors,
        value: _ctx.state.files,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.files) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      (_ctx.isRegister)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 1,
            class: "mt-3 w-full",
            placeholder: "Номер основного договора",
            options: _ctx.data_state.contracts.list,
            loading: _ctx.data_state.contracts.is_loading,
            failed: _ctx.data_state.contracts.is_failed,
            "is-invalid": _ctx.state_form$.contract_id.$error,
            "validation-errors": _ctx.state_form$.contract_id.$errors,
            "error-text": "При получении списка произошла ошибка",
            value: _ctx.state.contract_id,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.contract_id) = $event)),
            "infinite-scroll": "",
            onRefresh: _ctx.loadContracts,
            label: "number"
          }, null, 8, ["options", "loading", "failed", "is-invalid", "validation-errors", "value", "onRefresh"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}